// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3LElO","inner":"Footer_inner__1L8_W"};